import React from "react";
import Logo from "../assets/icons/cross-country.svg";
import Close from "../assets/icons/close.svg";
import Phone from "../assets/icons/tel.svg";
import Pin from "../assets/icons/location.svg";
import { Link, NavLink } from "react-router-dom";

type PropType = {
  onClickMenu: () => void;
};

const SideMenu = ({ onClickMenu }: PropType) => {
  const navLink = [
    {
      name: "about",
      to: "/about",
    },
    {
      name: "courier",
      to: "/courier",
    },
    {
      name: "haulage",
      to: "/haulage",
    },
    {
      name: "transit hotel",
      to: "/transit-hotel",
    },
    {
      name: "terminal",
      to: "/terminal",
    },
    {
      name: "contact",
      to: "/contact",
    },
  ];
  return (
    <div className=" bg-trans5  z-[9] fixed top-0 left-0 right-0 bottom-0 ">
      <div className="fixed bg-white flex flex-col top-0 bottom-0 left-0 w-[70%] right-0 px-4 py-4">
        <div className="flex justify-between items-center">
          <Link to="home" onClick={onClickMenu}>
            <img src={Logo} alt="" />
          </Link>
          <img src={Close} alt="" className="w-5" onClick={onClickMenu} />
        </div>
        <div className="flex flex-col justify-between mt-10 mb-10 h-full overflow-y-scroll ">
          <div className="flex flex-col justify-center items-start  capitalize  text-black font-normal text-base w-full">
            {navLink.map((item) => (
              <div
                className="cursor-pointer border-b py-6 w-full"
                key={item.to}
              >
                <NavLink
                  style={({ isActive }) =>
                    isActive
                      ? {
                          fontWeight: "600",
                        }
                      : undefined
                  }
                  to={item.to}
                  onClick={onClickMenu}
                >
                  {item.name}
                </NavLink>
              </div>
            ))}
          </div>
          <div className="flex flex-col items-center gap-5 py-5">
            <div className="flex items-center gap-2">
              <img src={Phone} alt="" />
              <a href="tel:+234 805 555 5595">+234 805 555 5595</a>
            </div>
            <div className="flex items-center gap-2">
              <img src={Pin} alt="" />
              <div>Lagos, Nigeria</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SideMenu;
